//import { ModalButton } from "@alien-game-server/sdk";
import { ModalButtonAction } from "@alien-game-server/sdk";
 
import { App } from "@system/App";
 
import { handleModalBtnsAction, hideElement, showElement } from "@utils/helpers";
import { Icon, IconType } from "./Icon";
 import gsap from 'gsap'
import { Layout } from "@system/Layout";
 

export class SdkModal {
  overlay = document.getElementById("details-overlay") as HTMLDivElement;
  placeholder = document.getElementById("modal-placeholder") as HTMLParagraphElement;
  btnsContainer = document.getElementById("modal-buttons-container") as HTMLDivElement;
  modalDescription = document.getElementById('game-modal-description') as HTMLParagraphElement
  CloseIcon = document.getElementById("details-modal-close") as HTMLImageElement
  isShow = false
  progressTimeline: gsap.core.Timeline | null = null;


  constructor() { }

  setTitle(title: string,description:string) {
    this.placeholder.innerText = title
        this.modalDescription.innerText = description
  }

  setHeaderIcon( icon:IconType, callback: ()=> void ){
    const xmark = Icon.getSVG({iconType:icon,size: 16,color: "white"})
    this.CloseIcon.innerHTML = ""
    this.CloseIcon.classList.remove("timer")
    this.CloseIcon.classList.add("button-gray")
    this.CloseIcon.appendChild(xmark)
    this.CloseIcon.onclick = ()=> {callback()}
    showElement(this.CloseIcon)
  }

  setHeaderHTML(element: HTMLElement){
    this.CloseIcon.classList.remove("button-gray")
    this.CloseIcon.classList.add("timer")

    this.CloseIcon.appendChild(element)
    showElement(this.CloseIcon)
  }

  setButtons(modalButtons: ModalButton[] | undefined,isRcModal?: boolean) {
    this.btnsContainer.innerHTML = "";
    if(modalButtons?.length == 0){
      this.btnsContainer.style.setProperty("height","0px")
    }else{
      this.btnsContainer.style.removeProperty("height")
    }
    const isOneButton = modalButtons?.length === 1
    modalButtons?.forEach((button, i) => {
      this.createButton(button.type,isOneButton, button.title, button.icon ,() => { handleModalBtnsAction({
        action:button.action,
        callback:()=>{
          this.hide()
          if(isRcModal){
            sessionStorage.setItem("realityCheckLastHiddenAt", String(Date.now()));
          }

        }})})
    })
  }

  // addButton(type: 'primary' | 'secondary', text: string, callback: () => void,titleAfterClick: string){
  //   this.btnsContainer.innerHTML = ""
  //   this.createButton(type,text,callback,titleAfterClick)
  // }

  createButton(type: ModalButtonTypes, isOneButton: boolean,text: string, icon: undefined | SVGElement, callback: () => void) {
    const button = document.createElement('div');
    button.className = `action-button ${type}`;

    if(icon && !isOneButton){
      button.appendChild(icon)
      button.classList.add("iconButton")
    }else{
      const textSpan = document.createElement('span')
      textSpan.setAttribute('data-text','')
      textSpan.classList.add('modal-button-text')
      textSpan.innerText = text
      button.appendChild(textSpan)
    }

    button.onclick = () => {
      const isDisabled = button.classList.contains("disabled")
      if(isDisabled) return;
      button.classList.add("disabled")
      //// console.log("clicked")
      callback()
    }
    this.btnsContainer.appendChild(button);

    return button; // Return the created button in case you need further manipulation
  }

  isHidden(){
    return this.overlay.classList.contains('hide')
  }

  async show(duration?: number | undefined) {
    hideElement(this.CloseIcon)
    // App.gameManager.game?.nickname?.hideNickName();
    // if(!Layout.IsDesktopOrLargeDesktop()){
    //   App.gameManager.game?.detailsModal?.hide();
    //   App.gameManager.game?.chat?.hide();
    //   App.gameManager.game?.historyModal?.hide();
    // }
   
   
    if(!!duration){
      const div = document.createElement("span");
      div.innerText = String(duration)
      this.setHeaderHTML(div)
      this.startProgress(duration, div)
    }
    
    
    showElement(this.overlay);
  }


  startProgress(timeToEndInMS: number = 0, element: HTMLElement) {
    // Kill previous timeline if any
    if (this.progressTimeline) {
      this.progressTimeline.kill();
      this.progressTimeline = undefined as any;
    }

    const totalMs = timeToEndInMS;
    const startTs = Date.now();
    const endTs = startTs + totalMs;

    // we just need something that ticks; duration is arbitrary, we'll kill it ourselves
    this.progressTimeline = gsap.timeline({
      repeat: -1,       // keep calling onUpdate
      onUpdate: () => {
        const now = Date.now();
        const remainingMs = Math.max(0, endTs - now);

        // convert to seconds with 1 decimal
        const remainingSeconds = remainingMs / 1000;
        const rounded = Math.ceil(remainingSeconds * 10) / 10;
        const res = rounded.toFixed(1);

        element.innerText = res;

        if (remainingMs <= 0) {
          // force final state
          element.innerText = "0.0";

          this.progressTimeline?.kill();
          this.progressTimeline = undefined as any;

          this.endProgress();

        }
      }
    });

    // tiny dummy tween just so the timeline has something
    this.progressTimeline.to({}, {
      duration: 0.1,
      ease: "linear"
    });
  }

  endProgress(){
      if (this.progressTimeline) {
          this.progressTimeline.kill(); // Stops animation and prevents onComplete
          this.progressTimeline = null;
      }
      this.hide()
  }


  hide() {
    hideElement(this.CloseIcon)
    hideElement(this.overlay);

   
  }
}




export interface ModalButton {
    title: string; 
    icon?: SVGElement;
    action: ModalButtonAction;
    type: ModalButtonTypes;
}


export enum ModalButtonTypes{
    primary = "primary",
    secondary = "secondary",
    tertiary = "tertiary",
}